/**
 * @generated SignedSource<<7d02f46a84799c855ec2e8ba83cd7c02>>
 * @relayHash babae662edc96a8ec65589a05b7eb9ba
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID babae662edc96a8ec65589a05b7eb9ba

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type SkillSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GENERAL_INTERNAL_MEDICINE" | "GYNAECOLOGY" | "LONG_COVID" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "RHEUMATOLOGY" | "SPORTS_MEDICINE" | "STUDY" | "SURGERY" | "TELE_GENERAL_PRACTITIONER" | "UROLOGY" | "VACCINATION_ADVICE";
export type UserRole = "CALL_CENTER_AGENT" | "CUSTOMER_SERVICE_CENTER" | "DOCTOR" | "MEDICAL_SUPERVISOR" | "NONE" | "NURSING_PROFESSIONAL" | "SOFIA_ADMIN" | "SOFIA_ADMIN_AI_ADMIN" | "SOFIA_ADMIN_BUSINESS_ADMIN" | "SOFIA_ADMIN_BUSINESS_EDITOR" | "SOFIA_ADMIN_MEDICAL_ADMIN" | "SOFIA_ADMIN_TECHNICAL_ADMIN";
export type fetchUsersQuery$variables = {
  input: string;
};
export type fetchUsersQuery$data = {
  readonly loginUser: ReadonlyArray<{
    readonly hasTelematikId: boolean;
    readonly role: UserRole;
    readonly roleData: {
      readonly ccaLanguages?: ReadonlyArray<Language>;
      readonly languages?: ReadonlyArray<{
        readonly fullySpottable: boolean;
        readonly skill: Language | null;
      }>;
      readonly preferredLanguage?: Language;
    } | null;
    readonly userName: string;
  }>;
  readonly users: ReadonlyArray<{
    readonly acsUserId: string | null;
    readonly firstName: string;
    readonly globalLocationNumber: string | null;
    readonly isDeleted: boolean;
    readonly lastName: string;
    readonly professionalTitle: string;
    readonly role: UserRole;
    readonly roleData: {
      readonly licensesInCountries?: ReadonlyArray<{
        readonly country: Country;
        readonly isFavoredInCountry: boolean;
      }>;
      readonly specialties?: ReadonlyArray<{
        readonly skill: SkillSpecialty | null;
      }>;
    } | null;
    readonly userName: string;
  }>;
};
export type fetchUsersQuery = {
  response: fetchUsersQuery$data;
  variables: fetchUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "professionalTitle",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "globalLocationNumber",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "acsUserId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skill",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillSpecialtySkillInformation",
  "kind": "LinkedField",
  "name": "specialties",
  "plural": true,
  "selections": [
    (v9/*:: as any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "LicenseInformation",
  "kind": "LinkedField",
  "name": "licensesInCountries",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFavoredInCountry",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "eq",
            "variableName": "input"
          }
        ],
        "kind": "ObjectValue",
        "name": "userName"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasTelematikId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "LanguageSkillInformation",
  "kind": "LinkedField",
  "name": "languages",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullySpottable",
      "storageKey": null
    },
    (v9/*:: as any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredLanguage",
  "storageKey": null
},
v16 = {
  "alias": "ccaLanguages",
  "args": null,
  "kind": "ScalarField",
  "name": "languages",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchUsersQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "roleData",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*:: as any*/),
                  (v11/*:: as any*/)
                ],
                "type": "Doctor",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "loginUser",
        "args": (v12/*:: as any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v4/*:: as any*/),
          (v13/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "roleData",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v14/*:: as any*/),
                  (v15/*:: as any*/)
                ],
                "type": "Doctor",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v16/*:: as any*/),
                  (v15/*:: as any*/)
                ],
                "type": "CallCenterAgent",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "fetchUsersQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "roleData",
            "plural": false,
            "selections": [
              (v17/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  (v18/*:: as any*/)
                ],
                "type": "Doctor",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v18/*:: as any*/)
                ],
                "type": "CallCenterAgent",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v18/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "loginUser",
        "args": (v12/*:: as any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v4/*:: as any*/),
          (v13/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "roleData",
            "plural": false,
            "selections": [
              (v17/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v14/*:: as any*/),
                  (v15/*:: as any*/),
                  (v18/*:: as any*/)
                ],
                "type": "Doctor",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v16/*:: as any*/),
                  (v15/*:: as any*/),
                  (v18/*:: as any*/)
                ],
                "type": "CallCenterAgent",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v18/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "babae662edc96a8ec65589a05b7eb9ba",
    "metadata": {},
    "name": "fetchUsersQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "eb43fcbd0d7cdb09b88efb40f4cb14a1";

export default node;
